export const REQUEST="REQUEST"
export const FAILURE="FAILURE"

export const GET_PRODUCT_SUCCESS="GET_DATA_SUCCESS"
export const EDIT_PRODUCT_SUCCESS="EDIT_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_SUCCESS="DELETE_PRODUCT_SUCCESS"